import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ModulesComponent from './ModulesComponent';
import MenuAction from '../../../../../modules/actions/MenuAction';
import LayoutAction from '../../../../../modules/actions/LayoutAction';

const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache,
  language: state.TranslationReducer.language,
});

const mapDispatchToProps = (dispatch) => ({
  layoutAction: bindActionCreators(LayoutAction, dispatch),
  menuAction: bindActionCreators(MenuAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModulesComponent);
